import type { FC } from 'react';
import { Outlet } from 'react-router-dom';

const AuthLayout: FC = () => (
  <main className="flex min-h-screen items-center justify-center bg-gradient-to-br from-brand-500 via-brand-400 to-brand-300 px-4 py-12">
    <div className="w-full max-w-md rounded-3xl bg-white/95 p-10 shadow-2xl backdrop-blur">
      <Outlet />
    </div>
  </main>
);

export default AuthLayout;
